import { Helmet } from "react-helmet-async";

const SITE = "https://www.opsiq.live";
const BRAND = "OpsIQ";

/**
 * Per-route SEO. Render at the top of each page.
 *
 *   <Seo
 *     title="GIDA — Digital Guest Experience Platform"
 *     description="..."
 *     path="/products/gida"
 *     image="/products/og-gida.jpg"        // absolute path on the site
 *     imageAlt="..."
 *     imageWidth={1200}
 *     imageHeight={630}
 *     type="website"                       // or "article"
 *   />
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = "/og-image.jpg?v=2",
  imageAlt = "OpsIQ — Operational Intelligence",
  imageWidth = 1200,
  imageHeight = 630,
  type = "website",
}) {
  const url = `${SITE}${path}`;
  const img = image.startsWith("http") ? image : `${SITE}${image}`;
  const fullTitle = title.includes("|") ? title : `${title} | ${BRAND}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:secure_url" content={img} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content={String(imageWidth)} />
      <meta property="og:image:height" content={String(imageHeight)} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:locale" content="en_GH" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
